import { Button } from '@/components/ui/button'
import { toast } from '@/components/ui/use-toast'
import { PaperPlaneIcon, UpdateIcon } from '@radix-ui/react-icons'
import { postFetcher } from 'api/swr'
import Navbar from 'components/Navbar'
import React from 'react'
import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import useSWRMutation from 'swr/mutation'

const Nav = () => {
  const { tid } = useParams()

  const { data: tonings } = useSWR(['/tonings', { tid }])
  const { data: layers } = useSWR(['/layers', { tid }])

  const { trigger, isMutating } = useSWRMutation(
    `/publish/draft`,
    postFetcher,
    {
      onSuccess: () => {
        toast({
          title: 'Review submitted',
          description: 'Your review has been submitted successfully',
          className: 'bg-green-500 text-white',
        })
      },
      onError: (error) => {
        console.error(error)
        toast({
          variant: 'destructive',
          title: 'Failed to submit review',
          description: error.message,
        })
      },
    },
  )
  const handleClick = () => {
    // 检查是否有 toning 没有绑定任何 layer
    if (tonings && layers) {
      const unboundTonings = tonings.filter((toning) => {
        const linkedLayers = layers.filter((layer) => layer.toning === toning.id)
        return linkedLayers.length === 0
      })

      if (unboundTonings.length > 0) {
        toast({
          variant: 'destructive',
          title: '提交失败',
          description: '存在染色没有绑定层级，请绑定或者删除',
        })
        return
      }
    }

    trigger({ tid })
  }
  return (
    <Navbar name="Neku workspace">
      <Button disabled={isMutating} variant="outline" onClick={handleClick}>
        {isMutating ? (
          <>
            <UpdateIcon className="mr-2 h-4 w-4 animate-spin" />
            <span>Submitting review</span>
          </>
        ) : (
          <>
            <PaperPlaneIcon className="mr-2 h-4 w-4 -rotate-45" />
            <span>Submit review</span>
          </>
        )}
      </Button>
    </Navbar>
  )
}

export default Nav
